exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wrapper__2Xre {\n  margin-top: 20px; }\n\n.note__Uknx {\n  font-size: 10px;\n  font-style: italic;\n  margin-top: 10px; }\n", "", {"version":3,"sources":["/app/src/ui/properties-panel/images/src/ui/properties-panel/images/compression-panel.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAClB;;AAED;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB,EAClB","file":"compression-panel.scss","sourcesContent":[".wrapper {\n  margin-top: 20px;\n}\n\n.note {\n  font-size: 10px;\n  font-style: italic;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "wrapper__2Xre",
	"note": "note__Uknx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/properties-panel/images/compression-panel.scss
// module id = 1448
// module chunks = 0